import {
  X,
  Printer,
  Pencil,
  Trash2,
  Calendar,
  Wallet,
  FileText,
  Hash,
  User,
  CheckCircle,
} from "lucide-react";

export default function CashTransactionViewModal({
  transaction,
  onClose,
}) {
  if (!transaction) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex justify-center items-center p-6">

      <div className="w-full max-w-5xl rounded-3xl bg-[#09090B] border border-white/10 shadow-2xl overflow-hidden">

        {/* Header */}

        <div className="flex justify-between items-center px-8 py-6 border-b border-white/10">

          <div>

            <h2 className="text-3xl font-serif">
              Cash Transaction
            </h2>

            <p className="text-gray-400 mt-1">
              Voucher #{transaction.voucher}
            </p>

          </div>

          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl bg-white/5 hover:bg-red-500/20 flex justify-center items-center transition"
          >
            <X size={18} />
          </button>

        </div>

        {/* Status */}

        <div className="px-8 pt-6">

          <span
            className={`px-4 py-2 rounded-full text-sm font-medium ${
              transaction.type === "Receipt"
                ? "bg-emerald-500/20 text-emerald-400"
                : "bg-rose-500/20 text-rose-400"
            }`}
          >
            {transaction.type}
          </span>

        </div>

        {/* Summary */}

        <div className="grid md:grid-cols-4 gap-6 p-8">

          <Card
            icon={<Wallet size={18} />}
            title="Amount"
            value={`₹${(
              transaction.debit || transaction.credit
            ).toLocaleString()}`}
            color="text-amber-400"
          />

          <Card
            icon={<Calendar size={18} />}
            title="Date"
            value={transaction.date}
          />

          <Card
            icon={<Hash size={18} />}
            title="Voucher"
            value={transaction.voucher}
          />

          <Card
            icon={<FileText size={18} />}
            title="Category"
            value={transaction.category}
          />

        </div>

        {/* Details */}

        <div className="px-8 pb-8">

          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">

            <h3 className="text-lg font-serif mb-6">
              Transaction Details
            </h3>

            <div className="grid md:grid-cols-2 gap-6">

              <Detail
                label="Transaction Type"
                value={transaction.type}
              />

              <Detail
                label="Cash Account"
                value="Main Cash"
              />

              <Detail
                label="Reference"
                value={transaction.reference || "-"}
              />

              <Detail
                label="Status"
                value="Approved"
              />

              <Detail
                label="Debit"
                value={
                  transaction.debit
                    ? `₹${transaction.debit.toLocaleString()}`
                    : "-"
                }
              />

              <Detail
                label="Credit"
                value={
                  transaction.credit
                    ? `₹${transaction.credit.toLocaleString()}`
                    : "-"
                }
              />

              <Detail
                label="Running Balance"
                value={`₹${transaction.balance.toLocaleString()}`}
              />

              <Detail
                label="Created By"
                value="Admin"
              />

            </div>

            <div className="mt-8">

              <p className="text-sm text-gray-400 mb-2">
                Description
              </p>

              <div className="rounded-xl border border-white/10 bg-black/30 p-4">
                {transaction.description}
              </div>

            </div>

          </div>

        </div>

        {/* Footer */}

        <div className="border-t border-white/10 bg-white/5 px-8 py-6 flex justify-between">

          <div className="flex gap-3">

            <button className="px-5 py-3 rounded-xl bg-white/5 border border-white/10 flex items-center gap-2 hover:bg-white/10 transition">

              <Printer size={18} />

              Print Voucher

            </button>

          </div>

          <div className="flex gap-3">

            <button className="px-5 py-3 rounded-xl bg-blue-500/20 text-blue-400 flex items-center gap-2 hover:bg-blue-500/30 transition">

              <Pencil size={18} />

              Edit

            </button>

            <button className="px-5 py-3 rounded-xl bg-red-500/20 text-red-400 flex items-center gap-2 hover:bg-red-500/30 transition">

              <Trash2 size={18} />

              Delete

            </button>

            <button
              onClick={onClose}
              className="px-6 py-3 rounded-xl bg-amber-400 text-black font-semibold"
            >
              Close
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

function Card({
  icon,
  title,
  value,
  color = "text-white",
}) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-5">

      <div className="flex justify-between items-center">

        <p className="text-xs uppercase tracking-widest text-gray-400">
          {title}
        </p>

        {icon}

      </div>

      <h3 className={`mt-4 text-2xl font-serif ${color}`}>
        {value}
      </h3>

    </div>
  );
}

function Detail({ label, value }) {
  return (
    <div>

      <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
        {label}
      </p>

      <div className="rounded-xl bg-black/30 border border-white/10 px-4 py-3">
        {value}
      </div>

    </div>
  );
}